import Clarity from "@microsoft/clarity";
import type { Identity } from "@wb/ui/analytics/useIdentity";

export const identity: Identity = (id, email) => {
  Clarity.identify(id, undefined, undefined, email ?? undefined);
};
